import { useRepositoryMutation } from '@mews-commander/data-access';
import { lt, showSuccessAlert } from '@mews/framework';

export const useRateCreate = () =>
    useRepositoryMutation('rates', 'add', {
        invalidateQueries: {
            rates: ['getOverviewEntries', 'getAll'],
            rateGroups: ['getOverviewEntries', 'getAll'],
            paymentAndCancellationPolicies: ['validate'],
        },
    });

export const useRateUpdate = () =>
    useRepositoryMutation('rates', 'update', {
        invalidateQueries: {
            rates: ['getOverviewEntries', 'getAll', 'getDetail'],
            rateGroups: ['getOverviewEntries', 'getAll'],
            paymentAndCancellationPolicies: ['validate'],
        },
    });

export const useUpdateDefault = (name: string) =>
    useRepositoryMutation('rates', 'updateDefault', {
        invalidateQueries: {
            rates: ['getOverviewEntries', 'getAll', 'getDetail'],
        },
        onSuccess: () => {
            showSuccessAlert({
                title: lt('EntityMadeDefaultSuccessMessage', {
                    entity: name,
                }),
            });
        },
    });

export const useUpdateEnabled = (isEnabled: boolean) =>
    useRepositoryMutation('rates', 'updateEnabled', {
        invalidateQueries: {
            rates: ['getOverviewEntries', 'getAll', 'getDetail'],
            rateGroups: ['getOverviewEntries', 'getAll'],
            paymentAndCancellationPolicies: ['validate'],
        },
        onSuccess: () => {
            showSuccessAlert({
                title: isEnabled ? lt('RateDeactivated') : lt('RateActivated'),
            });
        },
    });
